import DeleteIcon from '@atlaskit/icon/core/delete';
import { HIGHLIGHT_DELETE_CLASS } from '@databases/highlights/constants';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { ElementBeforeIconWrapper } from '../../../select-value-menu/ui/components';
import { type SelectionsEffectMenuItemBuilder } from '../types';

const CONTEXT_MENU_DELETE_COLUMN_HIGHLIGHT_ID = 'context-menu-delete-column';

export const deleteCurrentColumnMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canDeleteFields) {
    return skip;
  }

  return (showDialog) => ({
    key: SELECT_VALUE_MENU_ACTIONS.DELETE_FIELDS,
    content: context.formatMessage(messages['field-actions.delete'], {
      fieldCount: '1',
    }),
    onClick: () => {
      actions.column.handleDeleteFields([context.fieldId], showDialog);
      context.closeMenu();
    },
    onMouseEnter: () => {
      const layer = context.deletePreviewLayer;
      const resolve = context.resolveFieldIdToColIndex;

      if (layer && resolve) {
        const colIndex = resolve(context.fieldId);

        if (colIndex >= 0) {
          layer.add(
            {
              id: CONTEXT_MENU_DELETE_COLUMN_HIGHLIGHT_ID,
              anchor: { row: 0, col: colIndex },
              lead: { row: 0, col: colIndex },
            },
            'column',
            HIGHLIGHT_DELETE_CLASS
          );
        }
      }
    },
    onMouseLeave: () => {
      context.deletePreviewLayer?.remove(CONTEXT_MENU_DELETE_COLUMN_HIGHLIGHT_ID);
    },
    elemBefore: (
      <ElementBeforeIconWrapper>
        <DeleteIcon label="" spacing="spacious" />
      </ElementBeforeIconWrapper>
    ),
  });
};
